import { SVGAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

export const FloorPlanIcon = ({ className, ...props }: SVGAttributes<SVGElement>) => (
  <svg
    data-cy="floor-plan-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 26 26"
    fill="none"
    className={twMerge('h-5 w-5 stroke-current', className)}
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.7"
      d="M1.8 13h9m0-11.3V4m0 6.8v4.4m0 6.8v2.3m6-13.6h7.4m-1.8 13.4H3.6c-1 0-1.7-.7-1.7-1.7V3.6c0-1 .7-1.7 1.7-1.7h18.8c1 0 1.7.7 1.7 1.7v18.8c0 1-.7 1.7-1.7 1.7Z"
    />
  </svg>
)
